import React from 'react';

const RenderEuroFormSection = (component = [], { formik, isModifyUser, country } = {}, containerProps = {}) => (
    <div {...containerProps}>
        {component.map((entry, idx) => (
            <React.Fragment key={idx}>
                {Array.isArray(entry)
                    ? entry.map((Comp, i) => <Comp key={i} formik={formik} isModifyUser={isModifyUser} country={country} />)
                    : React.createElement(entry, { formik, isModifyUser, country })}
                {idx !== component.length - 1 && <hr />}
            </React.Fragment>
        ))}
    </div>
);

export default RenderEuroFormSection;
